// トップページの「開演」演出（文言・画像は変えない。見た目の飾りだけを足す）
// packs/static/open.js から読み込む
//
//   loading 画面（open.js が 8.5 秒で消す）  … ここは変えない。重いページの読み込み待ち
//   └ 消えた瞬間、客席の明かりが落ちた舞台で赤いビロードの幕がひだを寄せながら左右に開く
//      ├ 上の飾り幕（金の縁取りとふさ・王冠）が上がる
//      ├ 左上の灯体から光の筋が伸び、床から「まだ見ぬ感動を全ての人に」へ追い明かりが振られる
//      │   … 光が当たるのに合わせて一字ずつ灯る
//      ├ 客席の明かりが戻ると同時に、左右の下から紙吹雪の大砲
//      └ 右上の AUDITION がすべり込む          … 開演直後の一番目に入る時に、入団の入口を見せる
//   スクロール: カードは順番に舞台へ出てくる。旗飾りはギャラリーの頭に1本だけ
//
// JS が動かないとき・「動きを減らす」設定のときは、何も隠さず元のページのまま。

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// サイトのバナー（JOIN US・ファンサーバー）の旗と同じ4色
const FLAG_COLORS = ['#b8452f', '#e8b33a', '#4d6aa3', '#efe2cc'];
const CONFETTI_COLORS = ['#e8b33a', '#f6d77a', '#b8452f', '#4d6aa3', '#efe2cc', '#d9707f', '#ffffff'];

// 演出の時刻（幕が開き始める合図からの ms）
const T_SPOT = 900; // スポットライトが袖から入る
const T_SPOT_LAND = 2300; // 見出しに止まる
const T_HOUSE_UP = 3300; // 客席の明かりが戻る・紙吹雪
const T_CLEANUP = 9000;

const CROWN_SVG =
  '<svg class="stageCurtain__crown" viewBox="0 0 64 40" aria-hidden="true">' +
  '<path d="M4 34 L8 10 L20 22 L32 4 L44 22 L56 10 L60 34 Z"/>' +
  '<rect x="4" y="34" width="56" height="5" rx="1.5"/>' +
  '<circle cx="8" cy="9" r="3"/><circle cx="32" cy="4" r="3.4"/><circle cx="56" cy="9" r="3"/>' +
  '</svg>';

function buildCurtain() {
  const curtain = document.createElement('div');
  curtain.className = 'stageCurtain';
  curtain.setAttribute('aria-hidden', 'true');
  // 幕はひだ（縦の帯）の集まり。開くときは内側のひだほど早く・遠くへ動き、外側に寄って重なる
  const pleats = window.innerWidth < 600 ? 5 : 8;
  const panel = (side) => {
    let html = `<div class="stageCurtain__panel stageCurtain__panel--${side}">`;
    for (let i = 0; i < pleats; i += 1) {
      // k: 外側の端 0 → 内側（幕の合わせ目）1
      const k = pleats === 1 ? 1 : i / (pleats - 1);
      html += `<div class="stageCurtain__pleat" style="--k:${k.toFixed(3)};--w:${(100 / pleats).toFixed(3)}%"></div>`;
    }
    html += '<div class="stageCurtain__hem"></div></div>';
    return html;
  };
  // 飾り幕のふさ: 波（スカラップ）の継ぎ目ごとに1本
  const scallop = window.innerWidth < 600 ? 64 : 96;
  const tassels = Math.ceil(window.innerWidth / scallop) + 1;
  let tasselHtml = '';
  for (let i = 0; i <= tassels; i += 1) {
    tasselHtml += `<i class="stageCurtain__tassel" style="left:${i * scallop}px;--sway:${(i % 4) * 0.21}s"></i>`;
  }
  curtain.style.setProperty('--scallop', `${scallop}px`);
  curtain.innerHTML =
    '<div class="stageHouse"></div>' +
    panel('l') +
    panel('r') +
    `<div class="stageCurtain__valance">${CROWN_SVG}${tasselHtml}</div>`;
  document.body.appendChild(curtain);
  return curtain;
}

// 客席の暗がりにスポットライトの穴をあける。位置と大きさは JS で動かす
// 本物の舞台の追い明かり（ピンスポット）のように:
//   ・2階席の左奥の灯体から、もやの中に薄い光の筋（ビーム）が伸びる。ちりがゆっくり舞う
//   ・光の輪は床をすべるように見出しまで振られ（弧は描かない）、止まると絞りが少し開く
//   ・暗がりは濃くしすぎない。輪のふちは何段もぼかす
function runSpotlight(curtain, main) {
  const house = curtain.querySelector('.stageHouse');
  const h1 = main.querySelector('.topTextMessage h1');
  if (!house || !h1) return;
  const r = h1.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  // 止まる位置: 見出しの中心。見出しが画面外なら画面の中央上寄り
  const visible = r.bottom > 0 && r.top < vh && r.width > 0;
  const tx = visible ? r.left + r.width / 2 : vw / 2;
  const ty = visible ? r.top + r.height / 2 : vh * 0.4;
  const trx = Math.max(visible ? r.width * 1.5 : 0, 110, vw * 0.13);
  const try_ = Math.max(visible ? r.height * 0.7 : 0, 150);
  // 振り始め: 舞台の左手前の床
  const sx = vw * 0.16;
  const sy = vh * 0.78;
  // 灯体: 画面の左上の外
  const lx = -vw * 0.04;
  const ly = -vh * 0.08;

  // ビーム: 台形に切り抜いた光を外側でぼかす（clip-path の後に blur をかけるため入れ子）。
  // ちりはぼかすと消えるので、同じ形で切り抜いた別の層に置く
  const beam = document.createElement('div');
  beam.className = 'stageBeam';
  let motes = '';
  for (let i = 0; i < 48; i += 1) {
    motes += `<i style="--mx:${(Math.random() * 100).toFixed(1)}%;--my:${(Math.random() * 100).toFixed(1)}%;--md:${(5 + Math.random() * 5).toFixed(2)}s;--mw:${(-Math.random() * 6).toFixed(2)}s"></i>`;
  }
  beam.innerHTML = `<div class="stageBeam__glow"><div class="stageBeam__cone"></div></div><div class="stageBeam__dust">${motes}</div>`;
  house.after(beam);
  const cone = beam.querySelector('.stageBeam__cone');
  const dust = beam.querySelector('.stageBeam__dust');
  beam.style.setProperty('--lx', `${lx.toFixed(1)}px`);
  beam.style.setProperty('--ly', `${ly.toFixed(1)}px`);

  const PAN = T_SPOT_LAND - T_SPOT; // 振る時間
  const IRIS = 650; // 止まってから絞りが開ききるまで
  const t0 = performance.now();
  const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2);
  // 絞り: 少し開きすぎてから落ち着く
  const irisCurve = (t) => 1 + Math.sin(Math.PI * t) * 0.06 * (1 - t);
  const set = (x, y, rx, ry) => {
    house.style.setProperty('--sx', `${x.toFixed(1)}px`);
    house.style.setProperty('--sy', `${y.toFixed(1)}px`);
    house.style.setProperty('--rx', `${rx.toFixed(1)}px`);
    house.style.setProperty('--ry', `${ry.toFixed(1)}px`);
    // ビームは灯体から輪の左右のふちへ。輪の幅の 0.8 で当てると、ふちがなじむ
    const hw = rx * 0.8;
    const poly = `polygon(${lx - 4}px ${ly}px, ${lx + 18}px ${ly - 10}px, ${(x + hw).toFixed(1)}px ${(y + ry * 0.25).toFixed(1)}px, ${(x - hw).toFixed(1)}px ${(y + ry * 0.35).toFixed(1)}px)`;
    cone.style.clipPath = poly;
    dust.style.clipPath = poly;
  };
  const step = (now) => {
    const el = now - t0;
    if (el < PAN) {
      const e = easeInOut(el / PAN);
      // 振っている間は少し小さめの輪。寄るにつれて見出しの大きさへ
      const k = 0.7 + 0.25 * e;
      set(sx + (tx - sx) * e, sy + (ty - sy) * e, trx * k, try_ * k);
      requestAnimationFrame(step);
      return;
    }
    const t = Math.min(1, (el - PAN) / IRIS);
    const g = 0.95 + 0.05 * t;
    const k = g * irisCurve(t);
    set(tx, ty, trx * k, try_ * k);
    if (t < 1) requestAnimationFrame(step);
  };
  set(sx, sy, trx * 0.7, try_ * 0.7);
  house.classList.add('is-spot');
  beam.classList.add('is-on');
  requestAnimationFrame(step);
}

// 紙吹雪の大砲: 画面の左下・右下から斜め上へ打ち上げ、ひらひら落ちる
// 横（.x）・縦（.y）・紙の回転（.p）を入れ子にして、放物線と3Dのひらめきを CSS だけで描く
function fireConfetti() {
  const box = document.createElement('div');
  box.className = 'stageConfetti';
  box.setAttribute('aria-hidden', 'true');
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const perSide = vw < 600 ? 22 : 40;
  for (let side = 0; side < 2; side += 1) {
    const dir = side === 0 ? 1 : -1;
    for (let i = 0; i < perSide; i += 1) {
      const kind = i % 4; // 0: 細長いリボン 1: 四角 2: 丸 3: 星
      const size = 6 + Math.random() * 6;
      const w = kind === 0 ? size * 0.45 : size;
      const h = kind === 0 ? size * 2.4 : size;
      const reach = vw * (0.18 + Math.random() * 0.5); // 横にどこまで飛ぶか
      const peak = vh * (0.45 + Math.random() * 0.4); // どこまで上がるか
      const x = document.createElement('i');
      x.className = `stageConfetti__x stageConfetti__x--${side === 0 ? 'l' : 'r'}`;
      x.style.cssText = [
        `--dx:${(dir * reach).toFixed(0)}px`,
        `--up:${(-peak).toFixed(0)}px`,
        `--fall:${(vh * 0.15 + Math.random() * vh * 0.2).toFixed(0)}px`,
        `--dur:${(2.8 + Math.random() * 1.6).toFixed(2)}s`,
        `--wait:${(Math.random() * 0.25).toFixed(2)}s`,
        `--spin:${(0.5 + Math.random() * 0.9).toFixed(2)}s`,
        `--tilt:${(Math.random() * 360).toFixed(0)}deg`,
      ].join(';');
      x.innerHTML =
        `<i class="stageConfetti__y"><i class="stageConfetti__p stageConfetti__p--${kind}" ` +
        `style="width:${w.toFixed(1)}px;height:${h.toFixed(1)}px;background:${CONFETTI_COLORS[(i + side) % CONFETTI_COLORS.length]}"></i></i>`;
      box.appendChild(x);
    }
  }
  document.body.appendChild(box);
  setTimeout(() => box.remove(), 6000);
}

// 見出しの一字ずつの点灯用に、文字を i で包む（h1 の aria-label があるので読み上げは変わらない）
function splitHeroLine(main) {
  let n = 0;
  main.querySelectorAll('.topTextMessage h1 .keepTextLine').forEach((line) => {
    const text = line.textContent.trim();
    line.textContent = '';
    Array.from(text).forEach((ch) => {
      // span は使わない: 既存の .contentfitBox span（ぼかしの下敷き）が absolute で重なる
      const el = document.createElement('i');
      el.className = 'stageChar';
      el.style.setProperty('--i', n);
      el.textContent = ch;
      line.appendChild(el);
      n += 1;
    });
  });
}

// 旗飾り: ゆるく垂れたロープに三角の旗。旗の数は画面幅から決める
function buildBunting() {
  const wrap = document.createElement('div');
  wrap.className = 'stageBunting';
  wrap.setAttribute('aria-hidden', 'true');
  const width = Math.min(window.innerWidth, 1400);
  // スマホは約34px おき、PC は詰まって見えないよう約52px おき
  const flags = Math.max(9, Math.round(width / (width > 900 ? 52 : 34)));
  const sag = 14; // ロープのたるみ(px)
  let html = `<svg class="stageBunting__rope" viewBox="0 0 100 ${sag + 2}" preserveAspectRatio="none"><path d="M0 1 Q50 ${sag * 2 + 1} 100 1" vector-effect="non-scaling-stroke"/></svg>`;
  for (let i = 0; i < flags; i += 1) {
    const t = (i + 0.5) / flags;
    const y = 1 + sag * 4 * t * (1 - t) * 0.98; // 2次ベジエのたるみ: 中央で sag
    html += `<span class="stageBunting__flag" style="left:${(t * 100).toFixed(2)}%;top:${y.toFixed(1)}px;background:${FLAG_COLORS[i % FLAG_COLORS.length]};--sway:${(i % 5) * 0.37}s"></span>`;
  }
  wrap.innerHTML = html;
  return wrap;
}

// 舞台に出てくるもの: 演目ごとに、入ったら順番に
const RISE_GROUPS = [
  ['.p-newsIndex', '.showNewsInner', 'rise'],
  ['.iconIndex:not(.characterSection)', '.iconLink', 'pop'],
  // グッズの中身・作品のカードは既存の .elem.appear（top.js）で出てくるので、ここでは触らない
  ['.p-galleryIndex', '.eachImgContents-for', 'rise'],
  ['.p-tagIndex', 'a', 'rise'],
  ['.p-bannerIndex', 'a', 'rise'],
];

function setupRise(main) {
  if (!('IntersectionObserver' in window)) return;
  const sections = [];
  RISE_GROUPS.forEach(([sectionSel, itemSel, kind]) => {
    main.querySelectorAll(sectionSel).forEach((section) => {
      const items = Array.from(section.querySelectorAll(itemSel));
      if (!items.length) return;
      items.forEach((el, i) => {
        el.classList.add('stageRise', `stageRise--${kind}`);
        el.style.setProperty('--n', Math.min(i, 11));
      });
      sections.push(section);
    });
  });
  main.querySelectorAll('section > .stageBunting').forEach((b) => {
    if (!sections.includes(b.parentElement)) sections.push(b.parentElement);
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-onstage');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px' });
  sections.forEach((s) => io.observe(s));
}

document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('.topPageMain');
  if (!main || reduceMotion) return;
  const root = document.documentElement;

  // 旗飾り: ギャラリーの頭に1本だけ（全部の演目に張ると多すぎる）
  main.querySelectorAll('.p-galleryIndex .section-tt h2').forEach((h2) => {
    if (h2.textContent.trim() !== 'ギャラリー') return;
    const section = h2.closest('section');
    if (!section || section.querySelector(':scope > .stageBunting')) return;
    section.insertBefore(buildBunting(), section.firstChild);
  });

  setupRise(main);

  // loading 画面が無い（何らかの理由で既に消えている）ときは幕を出さない
  const start = document.querySelector('.start');
  if (!start || getComputedStyle(start).display === 'none') return;

  const curtain = buildCurtain();
  splitHeroLine(main);
  root.classList.add('stage-armed');

  let opened = false;
  const open = () => {
    if (opened) return;
    opened = true;
    root.classList.add('stage-up');
    setTimeout(() => runSpotlight(curtain, main), T_SPOT);
    setTimeout(() => {
      root.classList.add('stage-lit');
      fireConfetti();
    }, T_HOUSE_UP);
    setTimeout(() => {
      curtain.remove();
      root.classList.remove('stage-armed', 'stage-up', 'stage-lit');
      root.classList.add('stage-done');
    }, T_CLEANUP);
  };
  // open.js が loading を消し始めた合図
  document.addEventListener('circus:curtain', open);
  // 念のため: 合図が来なくても幕が残り続けないように
  setTimeout(open, 12000);
});
